export default __webpack_public_path__ + "static/grid_window_content-e1c37b5ce8938ff302632b4cd12b685f.png";